/* eslint-disable react-hooks/exhaustive-deps */
import {Suspense, useEffect, useState} from 'react'
import {Outlet} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider, LayoutSplashScreen} from '../_metronic/layout/core'
import {MasterInit} from '../_metronic/layout/MasterInit'
import {AuthInit} from './modules/auth'
import {ToastContainer} from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import ModalPopupWrapper from './common/ModalPopup/ModalPopupWrapper'
import {useDispatch, useSelector} from 'react-redux'
import {setIsThereNonSavedForm} from "./common/ModalPopup/reducer";
import {Modal} from "react-bootstrap";
import {useThemeMode} from "../_metronic/partials/layout/theme-mode/ThemeModeProvider";
import {useIntl} from "react-intl";

const App = () => {
  const isThereNonSavedForm = useSelector((state:any) => state?.isThereNonSavedForm  )
    const dispatch = useDispatch()
    useEffect(() => {
        console.log(isThereNonSavedForm)
        const unloadCallback = (event:any) => {
            if(!isThereNonSavedForm) return
            else if(isThereNonSavedForm) {
                dispatch(setIsThereNonSavedForm(false))
                event.preventDefault();
                event.returnValue = "";
                return "";
            }
        };

       if(isThereNonSavedForm) {
           window.addEventListener("beforeunload",  unloadCallback);
       }
    }, [isThereNonSavedForm]);
  const [showAlert, setShowAlert] = useState<boolean>(false)
  const  {mode} = useThemeMode()
  const intl = useIntl()

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <I18nProvider>
          <LayoutProvider>
            <AuthInit>
              <Outlet />
              <MasterInit />
            </AuthInit>
          </LayoutProvider>
          <ToastContainer />
          <Modal show={showAlert} centered>
              <div className='text-center p-5 w-100' data-bs-theme={mode}>
                  <div
                      className={'w-100 rounded ' + (mode === 'dark' ? ' bg-none ' : ' bg-white ')}
                      data-bs-theme={mode}
                  >
                      <div className='d-flex align-items-center justify-content-between'>
                          <div className='fw-bolder text-gray-700 py-3'>
                              {intl.formatMessage({id: 'INFORMATION'})}
                          </div>
                          <div
                              className='p-1 cursor-pointer'
                              onClick={() => {
                                  setShowAlert(false)
                              }}
                          >
                              <i className='fa fa-close text-danger'></i>
                          </div>
                      </div>
                      <div className={'text-start py-3'}>
                          <div>{intl.formatMessage({id: 'BEFORE_QUIT_CONFIRM_MESSAGE'})}</div>
                      </div>
                      <div className='d-flex align-items-center justify-content-evenly'>
                          <button
                              className={'btn btn-secondary'}
                              onClick={() => {
                                  setShowAlert(false)
                              }}
                          >
                              {intl.formatMessage({id: 'NO'})}
                          </button>
                          <button
                              className={'btn btn-primary'}
                              onClick={() => {
                                  setShowAlert(false)
                                  dispatch(setIsThereNonSavedForm(false))
                              }}
                          >
                              {intl.formatMessage({id: 'YES'})}
                          </button>
                      </div>
                  </div>
              </div>
          </Modal>
          <ModalPopupWrapper />
      </I18nProvider>
    </Suspense>
  )
}

export {App}
